//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets a patient by id.
 * @param id The patient id.
 */
export function getPatient(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.PatientDto> {
    let url_ = getBaseUrl() + "/api/patients/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPatient,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetPatient?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPatient(_response);
    });
}

function processGetPatient(response: AxiosResponse): Promise<Types.PatientDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPatientDto(resultData200);
        return Promise.resolve<Types.PatientDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientDto>(null as any);
}

/**
 * Edits a patient.
 * @param id The patient id.
 * @param updatedPatient Dto containing fields that needs to be changed
(all fields are optional, only fields that are present in HTTP request are changed)
 */
export function editPatient(id: number, updatedPatient: Types.PatchPatientDto, config?: AxiosRequestConfig | undefined): Promise<Types.PatientDto> {
    let url_ = getBaseUrl() + "/api/patients/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializePatchPatientDto(updatedPatient);

    let options_: AxiosRequestConfig = {
        ..._requestConfigEditPatient,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigEditPatient?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processEditPatient(_response);
    });
}

function processEditPatient(response: AxiosResponse): Promise<Types.PatientDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPatientDto(resultData200);
        return Promise.resolve<Types.PatientDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientDto>(null as any);
}

/**
 * Gets all patients.
 * @param patientIds (optional) 
 * @param searchQuery (optional) 
 * @param subtenantIds (optional) 
 * @param importIds (optional) 
 * @param insuranceNumber (optional) 
 * @param number (optional) 
 * @param numberSource (optional) 
 * @param states (optional) 
 * @param statuses (optional) 
 * @param sexTypes (optional) 
 * @param sqlFilterQuery (optional) 
 * @param lastActivityRange_StartDate (optional) 
 * @param lastActivityRange_EndDate (optional) 
 * @param lastVisitRange_StartDate (optional) 
 * @param lastVisitRange_EndDate (optional) 
 * @param tagIds (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param includeValues (optional) If this flag is true, response DTO contains Values.
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function getPatients(patientIds?: number[] | null | undefined, searchQuery?: string | null | undefined, subtenantIds?: number[] | null | undefined, importIds?: string[] | null | undefined, insuranceNumber?: string | null | undefined, number?: string | null | undefined, numberSource?: Types.NumberSource | null | undefined, states?: Types.PatientState[] | null | undefined, statuses?: Types.PatientStatus[] | null | undefined, sexTypes?: Types.SexType[] | null | undefined, sqlFilterQuery?: string | null | undefined, lastActivityRange_StartDate?: Date | undefined, lastActivityRange_EndDate?: Date | undefined, lastVisitRange_StartDate?: Date | undefined, lastVisitRange_EndDate?: Date | undefined, tagIds?: number[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, includeValues?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PageableListDtoOfPatientListDto> {
    let url_ = getBaseUrl() + "/api/patients?";
    if (patientIds !== undefined && patientIds !== null)
        patientIds && patientIds.forEach(item => { url_ += "PatientIds=" + encodeURIComponent("" + item) + "&"; });
    if (searchQuery !== undefined && searchQuery !== null)
        url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
    if (subtenantIds !== undefined && subtenantIds !== null)
        subtenantIds && subtenantIds.forEach(item => { url_ += "SubtenantIds=" + encodeURIComponent("" + item) + "&"; });
    if (importIds !== undefined && importIds !== null)
        importIds && importIds.forEach(item => { url_ += "ImportIds=" + encodeURIComponent("" + item) + "&"; });
    if (insuranceNumber !== undefined && insuranceNumber !== null)
        url_ += "InsuranceNumber=" + encodeURIComponent("" + insuranceNumber) + "&";
    if (number !== undefined && number !== null)
        url_ += "Number=" + encodeURIComponent("" + number) + "&";
    if (numberSource !== undefined && numberSource !== null)
        url_ += "NumberSource=" + encodeURIComponent("" + numberSource) + "&";
    if (states !== undefined && states !== null)
        states && states.forEach(item => { url_ += "States=" + encodeURIComponent("" + item) + "&"; });
    if (statuses !== undefined && statuses !== null)
        statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
    if (sexTypes !== undefined && sexTypes !== null)
        sexTypes && sexTypes.forEach(item => { url_ += "SexTypes=" + encodeURIComponent("" + item) + "&"; });
    if (sqlFilterQuery !== undefined && sqlFilterQuery !== null)
        url_ += "SqlFilterQuery=" + encodeURIComponent("" + sqlFilterQuery) + "&";
    if (lastActivityRange_StartDate === null)
        throw new Error("The parameter 'lastActivityRange_StartDate' cannot be null.");
    else if (lastActivityRange_StartDate !== undefined)
        url_ += "LastActivityRange.StartDate=" + encodeURIComponent(lastActivityRange_StartDate ? "" + lastActivityRange_StartDate.toISOString() : "") + "&";
    if (lastActivityRange_EndDate === null)
        throw new Error("The parameter 'lastActivityRange_EndDate' cannot be null.");
    else if (lastActivityRange_EndDate !== undefined)
        url_ += "LastActivityRange.EndDate=" + encodeURIComponent(lastActivityRange_EndDate ? "" + lastActivityRange_EndDate.toISOString() : "") + "&";
    if (lastVisitRange_StartDate === null)
        throw new Error("The parameter 'lastVisitRange_StartDate' cannot be null.");
    else if (lastVisitRange_StartDate !== undefined)
        url_ += "LastVisitRange.StartDate=" + encodeURIComponent(lastVisitRange_StartDate ? "" + lastVisitRange_StartDate.toISOString() : "") + "&";
    if (lastVisitRange_EndDate === null)
        throw new Error("The parameter 'lastVisitRange_EndDate' cannot be null.");
    else if (lastVisitRange_EndDate !== undefined)
        url_ += "LastVisitRange.EndDate=" + encodeURIComponent(lastVisitRange_EndDate ? "" + lastVisitRange_EndDate.toISOString() : "") + "&";
    if (tagIds !== undefined && tagIds !== null)
        tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
    if (values !== undefined && values !== null)
        values && Object.keys(values).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + values[key]) + "&"; });
    if (includeValues === null)
        throw new Error("The parameter 'includeValues' cannot be null.");
    else if (includeValues !== undefined)
        url_ += "IncludeValues=" + encodeURIComponent("" + includeValues) + "&";
    if (pagination_Offset === null)
        throw new Error("The parameter 'pagination_Offset' cannot be null.");
    else if (pagination_Offset !== undefined)
        url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
    if (pagination_Limit === null)
        throw new Error("The parameter 'pagination_Limit' cannot be null.");
    else if (pagination_Limit !== undefined)
        url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
    if (sorting_SortField !== undefined && sorting_SortField !== null)
        url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
    if (sorting_SortDirection === null)
        throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
    else if (sorting_SortDirection !== undefined)
        url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
    if (additionalSorting !== undefined && additionalSorting !== null)
        additionalSorting && additionalSorting.forEach((item, index) => {
            for (let attr in item)
    			if (item.hasOwnProperty(attr)) {
    				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
    			}
        });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPatients,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetPatients?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPatients(_response);
    });
}

function processGetPatients(response: AxiosResponse): Promise<Types.PageableListDtoOfPatientListDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPageableListDtoOfPatientListDto(resultData200);
        return Promise.resolve<Types.PageableListDtoOfPatientListDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PageableListDtoOfPatientListDto>(null as any);
}

/**
 * Creates a patient.
 * @param newPatient Request parameter
 */
export function createPatient(newPatient: Types.CreatePatientDto, config?: AxiosRequestConfig | undefined): Promise<Types.PatientDto> {
    let url_ = getBaseUrl() + "/api/patients";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreatePatientDto(newPatient);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreatePatient,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreatePatient?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreatePatient(_response);
    });
}

function processCreatePatient(response: AxiosResponse): Promise<Types.PatientDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("Invalid data was specified.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPatientDto(resultData200);
        return Promise.resolve<Types.PatientDto>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.initPatientDto(resultData201);
        return Promise.resolve<Types.PatientDto>(result201);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientDto>(null as any);
}

export function getPatientsByInsuranceData(firstName?: string | undefined, lastName?: string | undefined, dateOfBirth?: Date | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PatientListDto[]> {
    let url_ = getBaseUrl() + "/api/patients/get-by-insurance-data?";
    if (firstName === null)
        throw new Error("The parameter 'firstName' cannot be null.");
    else if (firstName !== undefined)
        url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
    if (lastName === null)
        throw new Error("The parameter 'lastName' cannot be null.");
    else if (lastName !== undefined)
        url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
    if (dateOfBirth === null)
        throw new Error("The parameter 'dateOfBirth' cannot be null.");
    else if (dateOfBirth !== undefined)
        url_ += "DateOfBirth=" + encodeURIComponent(dateOfBirth ? "" + Types.formatDate(dateOfBirth) : "") + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPatientsByInsuranceData,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetPatientsByInsuranceData?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPatientsByInsuranceData(_response);
    });
}

function processGetPatientsByInsuranceData(response: AxiosResponse): Promise<Types.PatientListDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initPatientListDto(item)
              );
            }
        return Promise.resolve<Types.PatientListDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientListDto[]>(null as any);
}

/**
 * Removes a patient.
 * @param id The patient id.
 * @param removePatientDto Deletion params
 */
export function removePatient(id: number, removePatientDto: Types.RemovePatientDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/patients/{id}/delete";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeRemovePatientDto(removePatientDto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemovePatient,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigRemovePatient?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemovePatient(_response);
    });
}

function processRemovePatient(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Removes all patient data.
 * @param id The patient id.
 */
export function deletePermanently(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/patients/{id}/delete-permanently";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDeletePermanently,
        ...config,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigDeletePermanently?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeletePermanently(_response);
    });
}

function processDeletePermanently(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Anonymizes a patient.
 * @param id The patient id.
 * @param removePatientDto Deletion params
 */
export function anonymize(id: number, removePatientDto: Types.RemovePatientDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/patients/{id}/anonymize";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeRemovePatientDto(removePatientDto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigAnonymize,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigAnonymize?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAnonymize(_response);
    });
}

function processAnonymize(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Restores patient.
 * @param id The patient id.
 */
export function restorePatient(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/patients/{id}/restore";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRestorePatient,
        ...config,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigRestorePatient?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRestorePatient(_response);
    });
}

function processRestorePatient(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Merge patients.
 * @param dto The merge params.
 */
export function mergePatients(dto: Types.MergePatientsDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/patients/merge";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeMergePatientsDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigMergePatients,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigMergePatients?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processMergePatients(_response);
    });
}

function processMergePatients(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Move patient to another subtenant
 * @param id The patient id.
 * @param subtenantId The subtenant id.
 * @param dto The move params.
 */
export function movePatient(id: number, subtenantId: number, dto: Types.MovePatientDto, config?: AxiosRequestConfig | undefined): Promise<Types.MovePatientResultDto> {
    let url_ = getBaseUrl() + "/api/patients/{id}/move/{subtenantId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (subtenantId === undefined || subtenantId === null)
      throw new Error("The parameter 'subtenantId' must be defined.");
    url_ = url_.replace("{subtenantId}", encodeURIComponent("" + subtenantId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeMovePatientDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigMovePatient,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigMovePatient?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processMovePatient(_response);
    });
}

function processMovePatient(response: AxiosResponse): Promise<Types.MovePatientResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initMovePatientResultDto(resultData200);
        return Promise.resolve<Types.MovePatientResultDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MovePatientResultDto>(null as any);
}

/**
 * Move patients from one subtenant to another
 * @param subtenantIdFrom The subtenant ID from which patients are being moved.
 * @param subtenantIdTo The subtenant ID to which patients are being moved.
 */
export function startMovePatients(subtenantIdFrom: number, subtenantIdTo: number, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/patients/move/from/{subtenantIdFrom}/to/{subtenantIdTo}";
    if (subtenantIdFrom === undefined || subtenantIdFrom === null)
      throw new Error("The parameter 'subtenantIdFrom' must be defined.");
    url_ = url_.replace("{subtenantIdFrom}", encodeURIComponent("" + subtenantIdFrom));
    if (subtenantIdTo === undefined || subtenantIdTo === null)
      throw new Error("The parameter 'subtenantIdTo' must be defined.");
    url_ = url_.replace("{subtenantIdTo}", encodeURIComponent("" + subtenantIdTo));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigStartMovePatients,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigStartMovePatients?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processStartMovePatients(_response);
    });
}

function processStartMovePatients(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

export function getMovePatientsResult(processId: string, config?: AxiosRequestConfig | undefined): Promise<Types.MovePatientsResultDto> {
    let url_ = getBaseUrl() + "/api/patients/move-result/{processId}";
    if (processId === undefined || processId === null)
      throw new Error("The parameter 'processId' must be defined.");
    url_ = url_.replace("{processId}", encodeURIComponent("" + processId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetMovePatientsResult,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetMovePatientsResult?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetMovePatientsResult(_response);
    });
}

function processGetMovePatientsResult(response: AxiosResponse): Promise<Types.MovePatientsResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initMovePatientsResultDto(resultData200);
        return Promise.resolve<Types.MovePatientsResultDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MovePatientsResultDto>(null as any);
}
let _requestConfigGetPatient: Partial<AxiosRequestConfig> | null;
export function getGetPatientRequestConfig() {
  return _requestConfigGetPatient;
}
export function setGetPatientRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPatient = value;
}
export function patchGetPatientRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPatient = patch(_requestConfigGetPatient ?? {});
}

let _requestConfigEditPatient: Partial<AxiosRequestConfig> | null;
export function getEditPatientRequestConfig() {
  return _requestConfigEditPatient;
}
export function setEditPatientRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigEditPatient = value;
}
export function patchEditPatientRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigEditPatient = patch(_requestConfigEditPatient ?? {});
}

let _requestConfigGetPatients: Partial<AxiosRequestConfig> | null;
export function getGetPatientsRequestConfig() {
  return _requestConfigGetPatients;
}
export function setGetPatientsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPatients = value;
}
export function patchGetPatientsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPatients = patch(_requestConfigGetPatients ?? {});
}

let _requestConfigCreatePatient: Partial<AxiosRequestConfig> | null;
export function getCreatePatientRequestConfig() {
  return _requestConfigCreatePatient;
}
export function setCreatePatientRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreatePatient = value;
}
export function patchCreatePatientRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreatePatient = patch(_requestConfigCreatePatient ?? {});
}

let _requestConfigGetPatientsByInsuranceData: Partial<AxiosRequestConfig> | null;
export function getGetPatientsByInsuranceDataRequestConfig() {
  return _requestConfigGetPatientsByInsuranceData;
}
export function setGetPatientsByInsuranceDataRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientsByInsuranceData = value;
}
export function patchGetPatientsByInsuranceDataRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientsByInsuranceData = patch(_requestConfigGetPatientsByInsuranceData ?? {});
}

let _requestConfigRemovePatient: Partial<AxiosRequestConfig> | null;
export function getRemovePatientRequestConfig() {
  return _requestConfigRemovePatient;
}
export function setRemovePatientRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemovePatient = value;
}
export function patchRemovePatientRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemovePatient = patch(_requestConfigRemovePatient ?? {});
}

let _requestConfigDeletePermanently: Partial<AxiosRequestConfig> | null;
export function getDeletePermanentlyRequestConfig() {
  return _requestConfigDeletePermanently;
}
export function setDeletePermanentlyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeletePermanently = value;
}
export function patchDeletePermanentlyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeletePermanently = patch(_requestConfigDeletePermanently ?? {});
}

let _requestConfigAnonymize: Partial<AxiosRequestConfig> | null;
export function getAnonymizeRequestConfig() {
  return _requestConfigAnonymize;
}
export function setAnonymizeRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAnonymize = value;
}
export function patchAnonymizeRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAnonymize = patch(_requestConfigAnonymize ?? {});
}

let _requestConfigRestorePatient: Partial<AxiosRequestConfig> | null;
export function getRestorePatientRequestConfig() {
  return _requestConfigRestorePatient;
}
export function setRestorePatientRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRestorePatient = value;
}
export function patchRestorePatientRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRestorePatient = patch(_requestConfigRestorePatient ?? {});
}

let _requestConfigMergePatients: Partial<AxiosRequestConfig> | null;
export function getMergePatientsRequestConfig() {
  return _requestConfigMergePatients;
}
export function setMergePatientsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigMergePatients = value;
}
export function patchMergePatientsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigMergePatients = patch(_requestConfigMergePatients ?? {});
}

let _requestConfigMovePatient: Partial<AxiosRequestConfig> | null;
export function getMovePatientRequestConfig() {
  return _requestConfigMovePatient;
}
export function setMovePatientRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigMovePatient = value;
}
export function patchMovePatientRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigMovePatient = patch(_requestConfigMovePatient ?? {});
}

let _requestConfigStartMovePatients: Partial<AxiosRequestConfig> | null;
export function getStartMovePatientsRequestConfig() {
  return _requestConfigStartMovePatients;
}
export function setStartMovePatientsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigStartMovePatients = value;
}
export function patchStartMovePatientsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigStartMovePatients = patch(_requestConfigStartMovePatients ?? {});
}

let _requestConfigGetMovePatientsResult: Partial<AxiosRequestConfig> | null;
export function getGetMovePatientsResultRequestConfig() {
  return _requestConfigGetMovePatientsResult;
}
export function setGetMovePatientsResultRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetMovePatientsResult = value;
}
export function patchGetMovePatientsResultRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetMovePatientsResult = patch(_requestConfigGetMovePatientsResult ?? {});
}